module.exports = __webpack_public_path__ + "static/media/bakvodvar_nidurtog_small.1ac61339.png";